import React from "react";
import Immutable from "immutable";

export const AuthContext = React.createContext(Immutable.Map());